(() => {
  const initialize = () => {
    const sticky = document.querySelector("[data-ba-main-sticky]");
    const stickyButton = sticky?.querySelector("[data-ba-main-sticky-action]");
    const addButton = document.querySelector(
      "basic-preset-builder [data-add], basic-bundle-builder [data-add], product-form .product-form__submit, product-form button[name='add']",
    );
    const variantPicker = document.querySelector(
      "basic-preset-builder, basic-bundle-builder, variant-selects, variant-radios, .product-form__input",
    );

    if (!sticky || !stickyButton || !addButton) return;

    if (sticky.dataset.themeRole !== "main") {
      sticky.classList.add("is-preview");
    }

    document.body.append(sticky);
    sticky.hidden = true;

    stickyButton.addEventListener("click", (event) => {
      event.preventDefault();
      const target = variantPicker || addButton;
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      if (target.id && history.replaceState) {
        history.replaceState(null, "", `#${target.id}`);
      }

      window.setTimeout(() => {
        if (Math.abs(target.getBoundingClientRect().top) > window.innerHeight) {
          target.scrollIntoView({ behavior: "auto", block: "start" });
        }
      }, 900);
    });

    const visibility = new Map();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => visibility.set(entry.target, entry.isIntersecting));
        const controlsVisible = Array.from(visibility.values()).some(Boolean);
        const hasPassedSelector = variantPicker?.getBoundingClientRect().bottom < 0;
        sticky.hidden = !hasPassedSelector || controlsVisible;
      },
      { threshold: 0.08 },
    );

    [variantPicker, addButton].filter(Boolean).forEach((target) => {
      visibility.set(target, false);
      observer.observe(target);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
